import React, { useState } from "react";
import "./index.css";
import modalImg from "../../assets/earn-baai-modal-img.png";
import arrow from "../../assets/right-arrow.png";
import { Link } from "react-router-dom";
import { Modal } from "antd";

import SurveyModal from "./ServeyModal";

const EarnBaaiTokensModal = ({ handleClose }) => {
  // for showing warning modal
  const [isWarningModalOpen, setWariningIsModalOpen] = useState(false);
  const showWarningModal = () => {
    setWariningIsModalOpen(true);
  };
  const handleWarningOk = () => {
    setWariningIsModalOpen(false);
  };
  const handleWarningCancel = () => {
    setWariningIsModalOpen(false);
  };
  return (
    <>
      <div className="earn-baai-modal-section">
        <div className="earn-baai-modal-header">
          <h3>Earn Baai Tokens</h3>
          <p>
            Install FOCII Extension, use it for 2 minutes and earn BAAI tokens.
          </p>
          <img className="" src={modalImg} alt="" />
        </div>
        <div className="steps-to-follow">
          Steps to follow:
          <ol>
            <li>
              Install FOCII Extension on your browser and login using your BAAI
              account credentials.
            </li>
            <li>
              Sit in front your desktop/laptop in a comfortable
              position(recommended sitting on a chair in front of a desk).
            </li>
            <li>
              Run FOCII Extension and start watching your favourite YouTube
              video for 2 minutes continuously to complete this task and earn
              BAAI tokens.
            </li>
          </ol>
        </div>
        <div className="earn-baai-modal-footer">
          <a
            className="deskstop-install-button"
            onClick={() => {
              handleClose();
            }}
            href="https://chromewebstore.google.com/detail/focii-youtube/jamlalnkhijfjgbohdakdfgdnidoghca?pli=1"
            target="_blank"
          >
            Install FOCII Extension <img src={arrow} alt="" />
          </a>{" "}
          <a
            className="mobile-install-button"
            onClick={() => {
              showWarningModal();
              handleClose();
            }}
            href="https://chromewebstore.google.com/detail/focii-youtube/jamlalnkhijfjgbohdakdfgdnidoghca?pli=1"
            target="_blank"
          >
            Install FOCII Extension <img src={arrow} alt="" />
          </a>{" "}
          <br />
          <a
            href="https://www.youtube.com"
            target="_blank"
            id="already-installed-btn"
          >
            {" "}
            Focii Extension already installed?
          </a>
          <p>
            We respect your privacy. We don’t share your personal data with any
            individual or organisation. Your data is safe with us.
          </p>
          <Link to="/privacy" className="privacy-policy-link">
            <span>Our Privacy Policy</span>
          </Link>
        </div>
      </div>

      <Modal
        className="warning-modal"
        centered
        footer={false}
        open={isWarningModalOpen}
        onOk={handleWarningOk}
        onCancel={handleWarningCancel}
      >
        <div className="warning-modal-style">
          <h4>Whoops!</h4>
          <p>
            Extensions can only be installed on desktops. Please switch to a
            desktop to continue.
          </p>
          <button onClick={handleWarningCancel}>Close</button>
        </div>
      </Modal>
    </>
  );
};

export default EarnBaaiTokensModal;
